import React, { useEffect } from "react";
import styled from '@emotion/styled';
import {gsap} from 'gsap';

export default ({
  html,
  styles,
  scripts
}) => {

  useEffect(()=>{
    if(scripts) {
      eval(scripts);
    }
    return () => {
    // console.log('removed');
    }
  }, [])

  const Wrapper = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    overflow: hidden;
    z-index: 0;
    ${styles || ''}
  `;

  return (
    <>
      {html && <Wrapper dangerouslySetInnerHTML={{__html:html}} />}
    </>
  );
};
